import { colorToRgba } from './themeColors.js';

export function projectCardColors(root = document) {
    const archive = root.closest?.('.project-archive') || root.querySelector?.('.project-archive');
    const cards = root.matches?.('[data-project-theme-color]')
        ? [root]
        : root.querySelectorAll?.('[data-project-theme-color]');

    if (!archive || !cards?.length) return;

    const rootStyles = getComputedStyle(document.documentElement);
    // The body may still be tweening from the previous page during init.
    const theme = archive.closest('[data-theme-color]')?.dataset.themeColor?.trim();
    const defaultColor = rootStyles.getPropertyValue(
        theme && theme !== 'none' ? `--color-background-${theme}` : '--color-background'
    ).trim() || rootStyles.getPropertyValue('--color-background').trim();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setBodyColor = (color) => {
        if (!color) return;

        gsap.killTweensOf(document.body, 'backgroundColor');
        gsap.to(document.body, {
            backgroundColor: colorToRgba(color),
            duration: reducedMotion ? 0 : 0.6,
            ease: 'power4.out',
            overwrite: 'auto'
        });
    };

    cards.forEach((card) => {
        if (card.dataset.colorInitialized === 'true') return;

        const theme = card.dataset.projectThemeColor?.trim();
        const color = rootStyles
            .getPropertyValue(`--color-background-${theme}`)
            .trim();

        if (!color) return;

        card.dataset.colorInitialized = 'true';

        card.addEventListener('mouseenter', () => setBodyColor(color));
        card.addEventListener('mouseleave', () => setBodyColor(defaultColor));
        card.addEventListener('focusin', () => setBodyColor(color));
        card.addEventListener('focusout', () => setBodyColor(defaultColor));
    });
}
